export const SET_USER_STATUS = 'SET_USER_STATUS';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const SET_USER_LOGOUT = 'SET_USER_LOGOUT';
export const NO_DATA_NA = 'N/A';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
